import React, { Component } from 'react'
import {Container,Row,Col} from 'react-bootstrap'
import Sidebar from '../Sidebar'
import Data from './Data'
import ApiService from '../../services/ApiService'
import { setProd } from '../../actions/cart_Action';
import { connect } from 'react-redux';

 class UploadedData extends Component {
  constructor(props) {
    // Inherit constructor
    super(props);
    // Bind functions
    this.loadUser = this.loadUser.bind(this);
    // Call `loadUser` before mounting the app
    this.loadUser();
  }

// Get latest user object from blockchain
loadUser() {
  // Extract `setUser` of `UserAction` and `user.name` of UserReducer from redux
  const { setProd} = this.props;
  // Send request the blockchain by calling the ApiService,
  // Get the user object and store the `win_count`, `lost_count` and `game_data` object
  return ApiService.getUserByName().then(items => {

    items.map(itemr =>{
    setProd(itemr)
 //   console.log(itemr)
    
    //console.log(inititem) 
    return      console.log() 
  })

  });
  
}
  render() {

    return (
      <div>      
      <div className="container-fluid">
            <Row>
              <Col sm={3}>
              <Sidebar/>
              </Col>

              <Col sm={9}>
              <br/>
              <Data eosio3={this.props.eosio2}/>
              </Col>
              </Row>
    </div>
   </div>
    )
  }
}
// Map all state to component props (for redux to connect)
const mapStateToProps = state => state;

// Map the following action to props
const mapDispatchToProps = {
  setProd: setProd,
};

// Export a redux connected component
export default connect(mapStateToProps, mapDispatchToProps)(UploadedData);